var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{attrs:{"variant":_vm.stateVariant}},[(_vm.loading)?_c('gl-loading-icon',{staticClass:"gl-mx-5",attrs:{"size":"sm"}}):[_vm._v(_vm._s(_vm.stateName))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }